import type {
    GA4ImageNavigationCategory,
    GTMEventReturnType,
    GA4ImageNavigationDirection
} from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMDetailImageNavigationModelReturnType extends GTMEventReturnType {
    click_text: GA4ImageNavigationDirection;
    click_category: GA4ImageNavigationCategory;
}

interface GTMDetailImageNavigationModelData {
    direction: GA4ImageNavigationDirection;
    category: GA4ImageNavigationCategory;
}

export default class GTMDetailImageNavigationModel extends GTMBaseModel {
    public static parseToGTMData({
        direction,
        category
    }: GTMDetailImageNavigationModelData): GTMDetailImageNavigationModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'detail_image_navigation',
            click_text: direction,
            click_category: category
        };
    }
}
